export const formatExcerpt = (excerpt?: string | null) =>
  excerpt?.replace("<p>", "")?.replace("</p>", "");
